module.exports = __webpack_public_path__ + "static/media/offices-edit.65f8c247.svg";